import makeStyles from "@material-ui/core/styles/makeStyles";
import {isWhite} from "../utils";

const useMiscellaneousStyles = makeStyles(theme => ({
    appBar: {
        backgroundColor: theme.custom.background,
        boxShadow: 'none',
        paddingLeft: theme.custom.sideBarWidth + 26,
    },
    qrButton: {
        width: "100%!important",
        padding: "10px 23px 10px 23px",
        height: 48,
        background: "white",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        color: theme.palette.success.igor,
        textAlign: 'center',
        borderRadius: 4,
        fontSize: 14,
        "& img": {
            marginRight: 7,
            width: 28,
            height: 28,
            border: "1px solid rgba(0, 0, 0, 0.1)"
        }
    },
    greenTextBlock: {
        backgroundColor: theme.palette.success.igor,
        padding: '7px 14px 7px 14px',
        borderRadius: '4px',
        color: "white",
        display: "inline-block"
    },
    coomingSoonText: {
        padding: '6px 14px 6px 14px',
        borderRadius: '4px',
        background: '#e2f6de',
        fontWeight: 'bold',
        display: 'inline-block',
        color: theme.palette.success.igor,
        height: 32,
    }, coomingSoonText2: {
        padding: '6px 14px 6px 14px',
        borderRadius: '4px',
        background: '#e2f6de',
        fontWeight: 'bold',
        display: 'inline-block',
        color: theme.palette.success.igor,
        height: 32,
        width: 1200
    },
    yellowLabel: {
        fontWeight: 'bold',
        fontSize: '14px',
        padding: '6px 14px 6px 14px',
        color: theme.palette.yellow.main,
        background: theme.palette.yellow.light,
        borderRadius: '4px',
    },
    greenLabel: {
        fontWeight: 'bold',
        fontSize: '14px',
        padding: '6px 14px 6px 14px',
        color: theme.palette.success.igor,
        position: 'relative',
        "&::before": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 0.1,
            zindex: -1,
            background: theme.palette.success.igor,
            borderRadius: '4px',
        }
    },
    verifiedLogo: {
        height: 18,
        marginLeft: 8,
        marginBottom:2,
        width: "auto"
    },
    UMCarousel: {
        width: "100%",
        overflow: "visible!important",
        '& *[class*="MuiIconButton-root"]': {
            width: '24px',
            height: '24px',
        },
        "@media(max-width:500px)": {
            "& .cardBox": {
                flexWrap: 'wrap'
            },
            "& .card": {
                width: "100%",
            }
        },
        "@media(max-width:417px)": {}
    },
    barMeter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& .star': {
            width: '14px',
            marginLeft: '8px'
        },
        '& .logo': {
            width: '24px',
            marginRight: '8px'
        },
        '& .valueB': {
            marginLeft: 'auto',
        },
        '& .bar': {
            height: '8px',
            borderRadius: '60px',
            backgroundColor: theme.palette.success.igor,
            width: '100%',
            position: 'absolute',
            transform: 'translateY(-50%)',
            minWidth: '5px'
        },
        '& .barWrapper': {
            width: '100%',
            marginRight: '8px',
            marginLeft: '8px',
            position: 'relative'
        }
    },
    cardBottomFade: {
      '&::after': {
          content: "''",
          width:'100%',
          height:'30px',
          left:0,
          bottom:'20px',
          position: 'absolute',
          background: `linear-gradient(180deg, ${!isWhite(theme.card.color) ? 'rgba(255,255,255,0)' : 'rgba(48, 48, 48, 0)'}  0%, ${!isWhite(theme.card.color) ? 'rgba(255,255,255,0.8)' : 'rgba(48, 48, 48, 0.8)' } 50%)`
      }
    },
    divider: {
      height: 2,
      width:"100%",
      backgroundColor: theme.palette.grey["200"],
      marginBottom: 14
    },
    carouselBtn: {
        '& span': {
            position:'absolute',
            top:0
        }
    },
    barMeterFixedSpan: {
        '& span': {
            width: '30px',
        },
    }
}), {index: 1})

export {useMiscellaneousStyles}